import React from 'react';
import { Fade } from 'react-awesome-reveal';
import './App.css';
import logo from './logo.svg';
import Lottie from 'lottie-react';
import animationData from './129789-digital-dollar-wallet.json';
import animationData2 from './70060-secure-payment.json';
import animationData3 from './110223-cashier.json';
import animationData4 from './123652-financial-charts-and-statistics-on-tab-with-up-arrow.json'
import animationData5 from './117293-identity-verification.json'

// Mock URLs for online images - replace these with actual image URLs
const secureTransactionsImage = "https://png.pngtree.com/png-clipart/20210613/original/pngtree-mobile-frame-png-transparent-image-and-vector-phone-mockup-png-image_6406671.png";
const instantPaymentsImage = "https://thumbnail.imgbin.com/4/18/16/mobile-phone-case-gadget-mobile-phone-accessories-mobile-phone-communication-device-UitG0kQW_t.jpg";
const crossBorderTransactionsImage = "https://thumbnail.imgbin.com/4/18/16/mobile-phone-case-gadget-mobile-phone-accessories-mobile-phone-communication-device-UitG0kQW_t.jpg";
const loyaltyProgramImage = "https://thumbnail.imgbin.com/4/18/16/mobile-phone-case-gadget-mobile-phone-accessories-mobile-phone-communication-device-UitG0kQW_t.jpg";






function HeadingSection({ heading, text, imgLeft, bullets, image, isLottie, animationData }) {
  return (
      <section className={imgLeft ? 'heading-section img-left' : 'heading-section'}>
        <Fade delay={400}>
        {isLottie ? 
            <Lottie animationData={animationData}  className="heading-logo"/> : 
            <img src={image} className="heading-logo" alt="section-logo" /> 
          }
        </Fade>
        <Fade delay={400}>
          <div>
            <h2>{heading}</h2>
            <p>{text}</p>
            <ul>
              {bullets.map((bullet, index) => <li key={index}>{bullet}</li>)}
            </ul>
          </div>
        </Fade>
      </section>
  );
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <main>
<div style={{marginTop:150,justifyContent:'center',alignItems:'center',textAlign:'center',paddingLeft:100,paddingRight:100}}>
<div style={{fontSize:35,fontWeight:'bolder'}}>Terms and Conditions</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
Welcome to mykase.com. By using our website or app, you agree to comply with and be bound by the following terms and conditions. Please read them carefully. If you do not agree with these terms, you should not use our website.  
</div>


<div style={{fontSize:35,fontWeight:'bolder'}}>Acceptance of Terms</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:30}}>
By accessing or using mykase.com or the myKASE app, you agree to be legally bound by these Terms and Conditions, as well as any updates or modifications. We reserve the right to amend these terms at any time, with or without prior notice. Continued use of the website after modifications indicates your acceptance of the updated terms. 
</div>
<div style={{fontSize:35,fontWeight:'bolder'}}>
Privacy Policy
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
Our Privacy Policy explains how we collect, use, and protect your personal information. By using MyKase.com or the myKASE app, you consent to the collection and use of information as outlined in our Privacy Policy. Please review our privacy policy for more details.
</div>
<div style={{fontSize:35,fontWeight:'bolder'}}>
Use of Website
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
You may use mykase.com or the myKASE app for lawful purposes only. You agree not to engage in any activities that could harm, disrupt, or impair the website, its services, or other users. Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.   
</div>


<div style={{fontSize:35,fontWeight:'bolder'}}>
Intellectual Property
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
All content, including text, graphics, logos, images, and software, on MyKase.com or the
myKASE app is the property of MyKase.com or its content suppliers and is protected by
intellectual property laws. You may not reproduce, distribute, modify, or create derivative
works without express permission from KASE Technologies.
Certain features may require you to create an account. You are responsible for
maintaining the confidentiality of your account information and agree to accept
responsibility for all activities that occur under your account. We reserve the right to
suspend or terminate accounts if we suspect any unauthorized activity. 
</div>


<div style={{fontSize:35,fontWeight:'bolder'}}>
Limitation of Liability
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
KASE Technologies is not liable for any damages that may arise from your use of our
website, including, but not limited to, direct, indirect, incidental, punitive, and
consequential damages. We make no warranties or representations regarding the
accuracy, reliability, or completeness of the content on our site.   
</div>


<div style={{fontSize:35,fontWeight:'bolder'}}>
Indemnification
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
You agree to indemnify and hold harmless KASE Technologies, its officers, employees, and agents from any claims, liabilities, damages, or expenses arising from your use of the site, your violation of these terms, or your violation of any rights of another.
</div>

<div style={{fontSize:35,fontWeight:'bolder'}}>
Termination
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
We reserve the right to terminate or suspend access to mykase.com or the myKASE
app, without prior notice, for conduct that we believe violates these Terms and
Conditions or is harmful to other users of the website or us. 
</div>

<div style={{fontSize:35,fontWeight:'bolder'}}>
Governing Law
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
These Terms and Conditions are governed by the laws Ontario Canada, without regard
to conflict of law principles. You agree to submit to the exclusive jurisdiction of the courts
in Ontario Canada for the resolution of any disputes arising from or relating to these
terms or your use of the website.
</div>


<div style={{fontSize:35,fontWeight:'bolder'}}>
Contact Us
</div>
<div style={{fontSize:20,paddingTop:20,paddingBottom:50}}>
If you have any questions about these Terms and Conditions, please contact us at:
hello@mykase.com
</div>


</div>
      </main>
    </div>
    
  );
}

export default App;
